import { all, call, fork, put, takeEvery } from 'redux-saga/effects';
import { storage, authFB } from '../../../helpers/Firebase';
import { servicePath, storagePath } from '../../../constants/defaultValues';
import { NotificationManager } from '../../../components/common/react-notifications';
import moment from 'moment';
import {
    SECTION_EQUIPMENT_AREA,
    SECTION_EQUIPMENT_COMPLEXITY,
    SECTION_EQUIPMENT_EQUIPMENT,
    SECTION_EQUIPMENT_LIST,
    SECTION_EQUIPMENT_ADD,
    SECTION_EQUIPMENT_UPDATE,
} from '../../actions';
import {
    SectionEquipmentAreaSuccess,
    SectionEquipmentAreaError,
    SectionEquipmentComplexitySuccess,
    SectionEquipmentComplexityError,
    SectionEquipmentEquipmentSuccess,
    SectionEquipmentEquipmentError,
    SectionEquipmentListSuccess,
    SectionEquipmentListError,
    SectionEquipmentAddSuccess,
    SectionEquipmentAddError,
    SectionEquipmentUpdateSuccess,
    SectionEquipmentUpdateError
} from '../../actions';

export function* watchSectionEquipmentArea() {
    yield takeEvery(SECTION_EQUIPMENT_AREA, onSectionEquipmentArea);
}

export function* watchSectionEquipmentComplexity() {
    yield takeEvery(SECTION_EQUIPMENT_COMPLEXITY, onSectionEquipmentComplexity);
}

export function* watchSectionEquipmentEquipment() {
    yield takeEvery(SECTION_EQUIPMENT_EQUIPMENT, onSectionEquipmentEquipment);
}

export function* watchSectionEquipmentList() {
    yield takeEvery(SECTION_EQUIPMENT_LIST, onSectionEquipmentList);
}

export function* watchSectionEquipmentAdd() {
    yield takeEvery(SECTION_EQUIPMENT_ADD, onSectionEquipmentAdd);
}

export function* watchSectionEquipmentUpdate() {
    yield takeEvery(SECTION_EQUIPMENT_UPDATE, onSectionEquipmentUpdate);
}
function getToken(auth) {
    return new Promise((resolve, reject) => {
        const unsubscribe = auth.onAuthStateChanged(user => {
            user.getIdToken().then((token) => {
                unsubscribe();
                resolve(token);
            });
        }, reject);
    });
}

const onSectionEquipmentAreaAsync = async (payload) => {
    let token = await getToken(authFB);
    const response = await fetch(servicePath + 'search/assessment/area', {
        method: 'POST', mode: 'cors', cache: 'no-cache',
        headers: { 'Content-Type': 'application/json', 'token': token },
        body: JSON.stringify(payload)
    })
        .then(response => response.json())
        .then(data => { return data; })
        .catch(err => console.log(err));
    return { "data": response };
};

const onSectionEquipmentComplexityAsync = async (payload) => {
    let token = await getToken(authFB);
    const response = await fetch(servicePath + 'search/assessment/complexity', {
        method: 'POST', mode: 'cors', cache: 'no-cache',
        headers: { 'Content-Type': 'application/json', 'token': token },
        body: JSON.stringify(payload)
    })
        .then(response => response.json())
        .then(data => { return data; })
        .catch(err => console.log(err));
    return { "data": response };
};

const onSectionEquipmentEquipmentAsync = async (payload) => {
    let token = await getToken(authFB);
    const response = await fetch(servicePath + 'search/assessment/equipment', {
        method: 'POST', mode: 'cors', cache: 'no-cache',
        headers: { 'Content-Type': 'application/json', 'token': token },
        body: JSON.stringify(payload)
    })
        .then(response => response.json())
        .then(data => { return data; })
        .catch(err => console.log(err));
    return { "data": response };
};


const onSectionEquipmentListAsync = async (payload) => {
    let token = await getToken(authFB);
    const response = await fetch(servicePath + 'assessment/section_equipment/list', {
        method: 'POST', mode: 'cors', cache: 'no-cache',
        headers: { 'Content-Type': 'application/json', 'token': token },
        body: JSON.stringify(payload)
    })
        .then(response => response.json())
        .then(data => { return data; })
        .catch(err => console.log(err));
    return { "data": response };
};

const onSectionEquipmentAddAsync = async (data) => {
    let token = await getToken(authFB);
    const response = await fetch(servicePath + 'assessment/section_equipment/add', {
        method: 'POST', mode: 'cors', cache: 'no-cache',
        headers: { 'Content-Type': 'application/json', 'token': token },
        body: JSON.stringify(data.payload)
    })
        .then(response => response.json())
        .then(data => { return data; })
        .catch(err => console.log(err));
    return { message: true, data: response };
};

const onSectionEquipmentUpdateAsync = async (data) => {
    let token = await getToken(authFB);
    const response = await fetch(servicePath + 'assessment/section_equipment/update', {
        method: 'POST', mode: 'cors', cache: 'no-cache',
        headers: { 'Content-Type': 'application/json', 'token': token },
        body: JSON.stringify(data.payload)
    })
        .then(response => response.json())
        .then(data => { return data; })
        .catch(err => console.log(err));
    return { message: true, data: response };
};

function* onSectionEquipmentArea(data) {
    try {
        const response = yield call(onSectionEquipmentAreaAsync, data.payload);
        yield put(SectionEquipmentAreaSuccess(response.data));
    } catch (error) {
        yield put(SectionEquipmentAreaError(error));
    }
}

function* onSectionEquipmentComplexity(data) {
    try {
        const response = yield call(onSectionEquipmentComplexityAsync, data.payload);
        yield put(SectionEquipmentComplexitySuccess(response.data));
    } catch (error) {
        yield put(SectionEquipmentComplexityError(error));
    }
}

function* onSectionEquipmentEquipment(data) {
    try {
        const response = yield call(onSectionEquipmentEquipmentAsync, data.payload);
        yield put(SectionEquipmentEquipmentSuccess(response.data));
    } catch (error) {
        yield put(SectionEquipmentEquipmentError(error));
    }
}

function* onSectionEquipmentList(data) {
    try {
        const response = yield call(onSectionEquipmentListAsync, data.payload);
        yield put(SectionEquipmentListSuccess(response.data));
    } catch (error) {
        yield put(SectionEquipmentListError(error));
    }
}

function* onSectionEquipmentAdd(data) {
    try {
        const response = yield call(onSectionEquipmentAddAsync, data);
        console.log(response)
        if (response.data.status === true) {
            NotificationManager.success(response.data.message, 'Exito', 3000, null, null, '');
        } else if (response.data.status === 'error') {
            NotificationManager.error(response.data.message, 'Error', 3000, null, null, '');
        }
        yield put(SectionEquipmentAddSuccess(response.data));
    } catch (error) {
        yield put(SectionEquipmentAddError(error));
        NotificationManager.error(response.data.message, 'Error', 3000, null, null, '');
    }
}

function* onSectionEquipmentUpdate(data) {
    try {
        const response = yield call(onSectionEquipmentUpdateAsync, data);
        if (response.data.status === true) {
            NotificationManager.success(response.data.message, 'Exito', 3000, null, null, '');
        } else if (response.data.status === 'error') {
            NotificationManager.error(response.data.message, 'Error', 3000, null, null, '');
        }

        yield put(SectionEquipmentUpdateSuccess(response.data));
    } catch (error) {
        yield put(SectionEquipmentUpdateError(error));
    }
}

export default function* rootSaga() {
    yield all([
        fork(watchSectionEquipmentArea),
        fork(watchSectionEquipmentComplexity),
        fork(watchSectionEquipmentEquipment),
        fork(watchSectionEquipmentList),
        fork(watchSectionEquipmentAdd),
        fork(watchSectionEquipmentUpdate)
    ]);
}